import React, { useState } from "react";
import { useQuery } from "./useQuery";

const CheckListContext = React.createContext({});

function CheckListContextProvider({ children }) {
  const [questionData, setQuestionData] = useState([
    { Category: "", questions: "", answer: "" },
  ]);
  const [Category, setCategory] = useState([]);
  const [checklistData, setChecklistData] = useState([]);
  const [errors, setErrors] = useState({});
  const [totalQuestions, setTotalQuestions] = useState({});
  const [tempJSON, setTempJSON] = useState({});
  const [ratingMetadata, setRatingMetadata] = useState({});
  const [loadCheck, setLoadCheck] = useState(false);
  const [rating, setRating] = useState(0);

  return (
    <CheckListContext.Provider
      value={{
        questionData,
        setQuestionData,
        errors,
        setErrors,
        Category,
        setCategory,
        tempJSON,
        setTempJSON,
        totalQuestions,
        setTotalQuestions,
        loadCheck,
        setLoadCheck,
        rating,
        setRating,
        ratingMetadata,
        setRatingMetadata,
        checklistData,
        setChecklistData,
      }}
    >
      {children}
    </CheckListContext.Provider>
  );
}

export { CheckListContextProvider, CheckListContext };
